import { useEffect } from 'react';
import { ServiceCart } from '@app/services/ServiceCart';
import { useAppDispatch, useAppSelector } from '@app/redux/hooks';
import { selectHeaderData } from '@app/redux/slices/header';
import { addProductInBasket } from '@redux/slices/ProductManagement';
import { ServiceEcommerce2 } from '@app/services/ServiceEcommerce';

/* eslint-disable camelcase */
declare global {
  interface Window {
    digiLayer: any;
    jivo_onOpen: () => void;
    jivo_onClose: () => void;
  }
}

export const DigineticaIntegration = () => {
  const { region } = useAppSelector(selectHeaderData);
  const { cartList } = useAppSelector(state => state.productManagement);
  const dispatch = useAppDispatch();
  useEffect(() => {
    const addToCart = (part, offerId, qty) => {
      const query = { part, qty, regionId: +region.REGION, productId: offerId };
      dispatch(addProductInBasket(query));
      ServiceEcommerce2.addToCart([
        {
          part,
          id: offerId,
          quantity: qty,
        },
      ]);
    };

    const removeFromCart = offerId => {
      const cartItem = cartList.find(x => x.id === offerId);
      if (cartItem) {
        ServiceEcommerce2.removeFromCart([
          {
            part: cartItem.part,
            id: offerId,
            quantity: 1,
          },
        ]);
      }
      return ServiceCart.remove(offerId, parseInt(region.REGION));
    };

    window.digiLayer = window.digiLayer || {};
    window.digiLayer.addToCart = addToCart;
    window.digiLayer.removeFromCart = removeFromCart;

    const cartState: any = {};
    for (let i = 0; i < cartList.length; i++) {
      const item = cartList[i];
      cartState[item.id] = item.quantity;
    }
    window.digiLayer.cartState = cartState;
  }, []);

  return <div />;
};
